<!-- Profile — Direction A: identity header + tabs + cards (Tailwind, no banner, no accordions) -->
<div class="min-h-full bg-[var(--app-base)]">
  <div class="max-w-[1060px] mx-auto px-6 py-6">

    <!-- Cover photo (the classic field backdrop, now as a slim banner) -->
    <div class="h-32 rounded-2xl bg-cover bg-center" style="background-image: url('assets/img/profile_farming.jpg')"></div>

    <!-- Identity header (only the avatar overlaps the cover; text sits below it) -->
    <div class="flex gap-4 pb-5 px-4">
      <span class="w-14 h-14 -mt-7 shrink-0 rounded-2xl bg-[var(--app-hover)] text-[var(--primary-dark)] text-xl font-extrabold flex items-center justify-center ring-4 ring-[var(--app-base)]">
        {{ initials }}
      </span>
      <div class="min-w-0 pt-2">
        <div class="text-[19px] font-extrabold text-gray-800 leading-tight truncate">{{ user?.name }} {{ user?.surname }}</div>
        <div class="text-[11.5px] text-gray-400 tabular-nums truncate">{{ user?.email }}</div>
        <div class="flex gap-1.5 mt-1.5">
          <span class="text-[9px] font-bold uppercase tracking-wider px-2 py-1 rounded-full bg-[var(--app-hover)] text-[var(--primary-dark)]">{{ selectedLanguage }}</span>
          <span *ngIf="user?.currency" class="text-[9px] font-bold uppercase tracking-wider px-2 py-1 rounded-full bg-[var(--app-surface)] border border-[var(--app-border)] text-gray-500">{{ user?.currency }}</span>
        </div>
      </div>
    </div>

    <!-- Tabs -->
    <div class="flex gap-1 border-b border-[var(--app-border)]">
      <button *ngFor="let tab of tabs" (click)="activeTab = tab.id"
              class="px-4 py-2.5 text-[12.5px] font-bold border-b-2 -mb-px transition-colors"
              [ngClass]="activeTab === tab.id
                ? 'text-[var(--primary-dark)] border-[var(--primary-dark)]'
                : 'text-gray-400 border-transparent hover:text-gray-600'">
        {{ tab.label | translate }}
      </button>
    </div>

    <!-- ============ PROFILE TAB ============ -->
    <div *ngIf="activeTab === 'profile'" class="grid md:grid-cols-2 gap-4 pt-5 items-start">
      <!-- Personal information -->
      <form [formGroup]="personalForm" (ngSubmit)="savePersonal()"
            class="bg-[var(--app-surface)] border border-[var(--app-border)] rounded-2xl p-5">
        <div class="text-[13.5px] font-bold text-gray-800 mb-4">{{ 'PROFILE.PERSONAL-INFORMATION' | translate }}</div>
        <label class="block mb-3">
          <span class="block text-[10px] font-bold uppercase tracking-wide text-gray-400 mb-1">{{ 'PROFILE.FIRST-NAME' | translate }}</span>
          <input formControlName="name" type="text"
                 class="w-full bg-[var(--app-base)] border border-[var(--app-border)] rounded-[10px] px-3 py-2 text-[13px] text-gray-800 outline-none focus:border-[var(--primary-dark)] transition-colors">
          <span *ngIf="personalForm.controls.name.touched && personalForm.controls.name.errors?.['required']" class="text-[10.5px] text-red-600">{{ 'PROFILE.ERROR-NAME-REQUIRED' | translate }}</span>
          <span *ngIf="personalForm.controls.name.touched && personalForm.controls.name.errors?.['minlength']" class="text-[10.5px] text-red-600">{{ 'PROFILE.ERROR-NAME-LENGTH' | translate }}</span>
          <span *ngIf="personalForm.controls.name.touched && personalForm.controls.name.errors?.['maxlength']" class="text-[10.5px] text-red-600">{{ 'PROFILE.ERROR-NAME-LENGTH-MAX' | translate }}</span>
        </label>
        <label class="block mb-4">
          <span class="block text-[10px] font-bold uppercase tracking-wide text-gray-400 mb-1">{{ 'PROFILE.LAST-NAME' | translate }}</span>
          <input formControlName="surname" type="text"
                 class="w-full bg-[var(--app-base)] border border-[var(--app-border)] rounded-[10px] px-3 py-2 text-[13px] text-gray-800 outline-none focus:border-[var(--primary-dark)] transition-colors">
          <span *ngIf="personalForm.controls.surname.touched && personalForm.controls.surname.errors?.['required']" class="text-[10.5px] text-red-600">{{ 'PROFILE.ERROR-SURNAME-REQUIRED' | translate }}</span>
          <span *ngIf="personalForm.controls.surname.touched && personalForm.controls.surname.errors?.['minlength']" class="text-[10.5px] text-red-600">{{ 'PROFILE.ERROR-SURNAME-LENGTH' | translate }}</span>
          <span *ngIf="personalForm.controls.surname.touched && personalForm.controls.surname.errors?.['maxlength']" class="text-[10.5px] text-red-600">{{ 'PROFILE.ERROR-SURNAME-LENGTH-MAX' | translate }}</span>
        </label>
        <div class="flex justify-end">
          <button type="submit" [disabled]="personalForm.invalid"
                  class="px-4 py-2 rounded-[10px] bg-[var(--primary-dark)] text-white text-[11.5px] font-bold hover:opacity-90 disabled:opacity-40 transition-opacity">
            {{ 'PROFILE.SAVE' | translate }}
          </button>
        </div>
      </form>

      <!-- Contact information -->
      <form [formGroup]="contactForm" (ngSubmit)="saveContact()"
            class="bg-[var(--app-surface)] border border-[var(--app-border)] rounded-2xl p-5">
        <div class="text-[13.5px] font-bold text-gray-800 mb-4">{{ 'PROFILE.CONTACT-INFORMATION' | translate }}</div>
        <label class="block mb-3">
          <span class="block text-[10px] font-bold uppercase tracking-wide text-gray-400 mb-1">{{ 'PROFILE.EMAIL-ADDRESS' | translate }}</span>
          <input [value]="user?.email" type="email" disabled
                 class="w-full bg-[var(--app-hover)] border border-[var(--app-border)] rounded-[10px] px-3 py-2 text-[13px] text-gray-400">
        </label>
        <label class="block mb-4">
          <span class="block text-[10px] font-bold uppercase tracking-wide text-gray-400 mb-1">{{ 'PROFILE.CELLPHONE-NUMBER' | translate }}</span>
          <input formControlName="cell" type="tel"
                 class="w-full bg-[var(--app-base)] border border-[var(--app-border)] rounded-[10px] px-3 py-2 text-[13px] text-gray-800 outline-none focus:border-[var(--primary-dark)] transition-colors">
          <span *ngIf="contactForm.controls.cell.touched && contactForm.controls.cell.errors?.['required']" class="text-[10.5px] text-red-600">{{ 'PROFILE.ERROR-CELL-REQUIRED' | translate }}</span>
          <span *ngIf="contactForm.controls.cell.touched && contactForm.controls.cell.errors?.['pattern']" class="text-[10.5px] text-red-600">{{ 'PROFILE.ERROR-CELL-PATTERN' | translate }}</span>
        </label>
        <div class="flex justify-end">
          <button type="submit" [disabled]="contactForm.invalid"
                  class="px-4 py-2 rounded-[10px] bg-[var(--primary-dark)] text-white text-[11.5px] font-bold hover:opacity-90 disabled:opacity-40 transition-opacity">
            {{ 'PROFILE.SAVE' | translate }}
          </button>
        </div>
      </form>
    </div>

    <!-- ============ PREFERENCES TAB ============ -->
    <div *ngIf="activeTab === 'preferences'" class="grid md:grid-cols-2 gap-4 pt-5 items-start">
      <!-- General -->
      <div class="bg-[var(--app-surface)] border border-[var(--app-border)] rounded-2xl p-5">
        <div class="text-[13.5px] font-bold text-gray-800 mb-2">{{ 'PROFILE.GENERAL' | translate }}</div>

        <div class="flex items-center gap-3 py-3 border-t border-[var(--app-border)]">
          <div class="min-w-0">
            <div class="text-[12.5px] font-semibold text-gray-700">{{ 'PROFILE.LANGUAGE' | translate }}</div>
            <div class="text-[10.5px] text-gray-400">{{ 'PROFILE.LANGUAGE-HINT' | translate }}</div>
          </div>
          <span class="flex-1"></span>
          <select [(ngModel)]="selectedLanguage"
                  class="bg-[var(--app-base)] border border-[var(--app-border)] rounded-lg px-2.5 py-1.5 text-[12px] font-semibold text-gray-700 outline-none">
            <option *ngFor="let language of languageList" [value]="language.code">{{ language.label }}</option>
          </select>
          <button (click)="submitLang()"
                  class="px-3 py-1.5 rounded-lg bg-[var(--app-hover)] text-[var(--primary-dark)] text-[11px] font-bold hover:opacity-80 transition-opacity">
            {{ 'PROFILE.APPLY' | translate }}
          </button>
        </div>

        <div class="flex items-center gap-3 py-3 border-t border-[var(--app-border)]">
          <div class="min-w-0">
            <div class="text-[12.5px] font-semibold text-gray-700">{{ 'PROFILE.LANDING-PAGE' | translate }}</div>
            <div class="text-[10.5px] text-gray-400">{{ 'PROFILE.LANDING-PAGE-HINT' | translate }}</div>
          </div>
          <span class="flex-1"></span>
          <select [(ngModel)]="selectedLanding"
                  class="bg-[var(--app-base)] border border-[var(--app-border)] rounded-lg px-2.5 py-1.5 text-[12px] font-semibold text-gray-700 outline-none">
            <option *ngFor="let landing of landings" [value]="landing.value">{{ landing.viewValue }}</option>
          </select>
        </div>

        <div class="flex items-center gap-3 py-3 border-t border-[var(--app-border)]">
          <div class="text-[12.5px] font-semibold text-gray-700">{{ 'PROFILE.CURRENCY' | translate }}</div>
          <span class="flex-1"></span>
          <select [(ngModel)]="selectedCurrency"
                  class="bg-[var(--app-base)] border border-[var(--app-border)] rounded-lg px-2.5 py-1.5 text-[12px] font-semibold text-gray-700 outline-none">
            <option *ngFor="let currency of currencies" [value]="currency.value">{{ currency.viewValue }}</option>
          </select>
        </div>

        <div class="flex justify-end pt-2">
          <button (click)="savePreferences()"
                  class="px-4 py-2 rounded-[10px] bg-[var(--primary-dark)] text-white text-[11.5px] font-bold hover:opacity-90 transition-opacity">
            {{ 'PROFILE.SAVE' | translate }}
          </button>
        </div>
      </div>

      <!-- Maps (coming soon) -->
      <div class="bg-[var(--app-surface)] border border-[var(--app-border)] rounded-2xl p-5">
        <div class="text-[13.5px] font-bold text-gray-800 mb-2 flex items-center gap-2">
          {{ 'PROFILE.MAPS-PREFERENCES' | translate }}
          <span class="text-[8.5px] font-bold uppercase tracking-wider px-2 py-1 rounded-full bg-[var(--app-hover)] text-[var(--primary-dark)]">{{ 'PROFILE.COMING-SOON' | translate }}</span>
        </div>
        <div class="opacity-45 pointer-events-none select-none">
          <div class="flex items-center gap-3 py-3 border-t border-[var(--app-border)]">
            <div class="text-[12.5px] font-semibold text-gray-700">{{ 'PROFILE.FIELD-LABEL-SIZE' | translate }}</div>
            <span class="flex-1"></span>
            <span class="w-8 h-[18px] rounded-full bg-gray-300 relative after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:w-3.5 after:h-3.5 after:rounded-full after:bg-white"></span>
          </div>
          <div class="flex items-center gap-3 py-3 border-t border-[var(--app-border)]">
            <div class="text-[12.5px] font-semibold text-gray-700">{{ 'PROFILE.FIELD-LABEL-CROP' | translate }}</div>
            <span class="flex-1"></span>
            <span class="w-8 h-[18px] rounded-full bg-gray-300 relative after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:w-3.5 after:h-3.5 after:rounded-full after:bg-white"></span>
          </div>
          <div class="flex items-center gap-3 py-3 border-t border-[var(--app-border)]">
            <div class="text-[12.5px] font-semibold text-gray-700">{{ 'PROFILE.LABEL-LAYOUT' | translate }}</div>
            <span class="flex-1"></span>
            <span class="text-[11px] font-semibold text-gray-400 bg-[var(--app-base)] border border-[var(--app-border)] rounded-lg px-2.5 py-1.5">Stacked ▾</span>
          </div>
          <div class="flex items-center gap-3 py-3 border-t border-[var(--app-border)]">
            <div class="text-[12.5px] font-semibold text-gray-700">{{ 'PROFILE.DEFAULT-IMAGERY' | translate }}</div>
            <span class="flex-1"></span>
            <span class="text-[11px] font-semibold text-gray-400 bg-[var(--app-base)] border border-[var(--app-border)] rounded-lg px-2.5 py-1.5">NDVI ▾</span>
          </div>
        </div>
        <p class="text-[10.5px] text-gray-400 pt-3">{{ 'PROFILE.COMING-SOON-HINT' | translate }}</p>
      </div>
    </div>

    <!-- ============ SECURITY TAB ============ -->
    <div *ngIf="activeTab === 'security'" class="grid md:grid-cols-2 gap-4 pt-5 items-start">
      <form [formGroup]="passwordForm" (ngSubmit)="savePassword()"
            class="bg-[var(--app-surface)] border border-[var(--app-border)] rounded-2xl p-5">
        <div class="text-[13.5px] font-bold text-gray-800 mb-4">{{ 'PROFILE.PASSWORD' | translate }}</div>

        <label class="block mb-3">
          <span class="block text-[10px] font-bold uppercase tracking-wide text-gray-400 mb-1">{{ 'PROFILE.OLD-PASSWORD' | translate }}</span>
          <span class="relative block">
            <input formControlName="oldPassword" [type]="showPasswords.oldPassword ? 'text' : 'password'"
                   class="w-full bg-[var(--app-base)] border border-[var(--app-border)] rounded-[10px] px-3 py-2 pr-9 text-[13px] text-gray-800 outline-none focus:border-[var(--primary-dark)] transition-colors">
            <span (click)="showPasswords.oldPassword = !showPasswords.oldPassword"
                  class="material-icons absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 cursor-pointer" style="font-size: 16px">
              {{ showPasswords.oldPassword ? 'visibility_off' : 'visibility' }}
            </span>
          </span>
          <span *ngIf="passwordForm.controls.oldPassword.touched && passwordForm.controls.oldPassword.errors?.['required']" class="text-[10.5px] text-red-600">{{ 'PROFILE.ERROR-OLD-PASS' | translate }}</span>
        </label>

        <label class="block mb-3">
          <span class="block text-[10px] font-bold uppercase tracking-wide text-gray-400 mb-1">{{ 'PROFILE.NEW-PASSWORD' | translate }}</span>
          <span class="relative block">
            <input formControlName="newPassword" [type]="showPasswords.newPassword ? 'text' : 'password'"
                   class="w-full bg-[var(--app-base)] border border-[var(--app-border)] rounded-[10px] px-3 py-2 pr-9 text-[13px] text-gray-800 outline-none focus:border-[var(--primary-dark)] transition-colors">
            <span (click)="showPasswords.newPassword = !showPasswords.newPassword"
                  class="material-icons absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 cursor-pointer" style="font-size: 16px">
              {{ showPasswords.newPassword ? 'visibility_off' : 'visibility' }}
            </span>
          </span>
          <span *ngIf="passwordForm.controls.newPassword.touched && passwordForm.controls.newPassword.errors?.['required']" class="text-[10.5px] text-red-600">{{ 'PROFILE.ERROR-NEW-PASS-REQUIRED' | translate }}</span>
          <span *ngIf="passwordForm.controls.newPassword.touched && passwordForm.controls.newPassword.errors?.['pattern']" class="text-[10.5px] text-red-600">{{ 'PROFILE.ERROR-NEW-PASS-PATTERN' | translate }}</span>
        </label>

        <label class="block mb-4">
          <span class="block text-[10px] font-bold uppercase tracking-wide text-gray-400 mb-1">{{ 'PROFILE.CONFIRM-PASSWORD' | translate }}</span>
          <span class="relative block">
            <input formControlName="confirmPassword" [type]="showPasswords.confirmPassword ? 'text' : 'password'"
                   class="w-full bg-[var(--app-base)] border border-[var(--app-border)] rounded-[10px] px-3 py-2 pr-9 text-[13px] text-gray-800 outline-none focus:border-[var(--primary-dark)] transition-colors">
            <span (click)="showPasswords.confirmPassword = !showPasswords.confirmPassword"
                  class="material-icons absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 cursor-pointer" style="font-size: 16px">
              {{ showPasswords.confirmPassword ? 'visibility_off' : 'visibility' }}
            </span>
          </span>
          <span *ngIf="passwordForm.controls.confirmPassword.touched && passwordForm.controls.confirmPassword.errors?.['required']" class="text-[10.5px] text-red-600">{{ 'PROFILE.ERROR-CONFIRM-PASS' | translate }}</span>
          <span *ngIf="passwordForm.controls.confirmPassword.touched && passwordForm.controls.confirmPassword.errors?.['confirmedValidator']" class="text-[10.5px] text-red-600">{{ 'PROFILE.ERROR-CONFIRM-PASS-NOT-MATCH' | translate }}</span>
        </label>

        <p *ngIf="passwordErrorMessage" class="text-[11px] text-red-600 mb-3">{{ passwordErrorMessage }}</p>

        <div class="flex justify-end">
          <button type="submit" [disabled]="passwordForm.invalid"
                  class="px-4 py-2 rounded-[10px] bg-[var(--primary-dark)] text-white text-[11.5px] font-bold hover:opacity-90 disabled:opacity-40 transition-opacity">
            {{ 'PROFILE.UPDATE' | translate }}
          </button>
        </div>
      </form>
    </div>

    <!-- ============ ACCOUNT TAB ============ -->
    <div *ngIf="activeTab === 'account'" class="pt-5">
      <div class="bg-[var(--app-surface)] border border-red-200 rounded-2xl p-5 max-w-[520px]">
        <div class="text-[13.5px] font-bold text-red-600 mb-2">{{ 'PROFILE.DANGER-ZONE' | translate }}</div>
        <div class="flex items-center gap-4">
          <p class="text-[12px] text-gray-500 m-0">{{ 'PROFILE.DELETE-PROFILE-MESSAGE' | translate }}</p>
          <span class="flex-1"></span>
          <button (click)="openConfirmProfileDeleteDialog()"
                  class="shrink-0 px-4 py-2 rounded-[10px] bg-red-50 text-red-600 text-[11px] font-bold hover:bg-red-100 transition-colors">
            {{ 'PROFILE.DELETE-BUTTON' | translate }}
          </button>
        </div>
      </div>
    </div>

  </div>
</div>
